module.exports = __webpack_public_path__ + "img/b3-1.b9f214e.png";